import { getImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'

import { BackgroundImage } from '@application/Interfaces/Atoms/BackgroundImage/BackgroundImage'
import { WidgetElement } from '@application/Interfaces/Features/WidgetElement'
import type { HeroSectionComponent } from '@application/Types/ComponentTypes'

import { HeroDescription } from './HeroDescription/HeroDescription'
import { HeroHeader } from './HeroHeader/HeroHeader'
import { Container, ContentWrapper, HeroWrapper } from './HeroSection.styled'
import { SlideInImage } from './SlideInImage/SlideInImage'

export const HeroSection = ({
    header,
    description,
    showQuoteForm,
    quoteFormDefaultMode,
    backgroundImage,
    slideInImage,
    mode,
    MiddleContent,
    backgroundImageAnimation,
    slideInImageAnimation,
}: HeroSectionComponent): JSX.Element => {
    const image = getImage(backgroundImage.localFile) as IGatsbyImageData

    return (
        <HeroWrapper>
            <BackgroundImage
                image={image}
                title={backgroundImage.alternativeText}
                backgroundImageAnimation={backgroundImageAnimation}
            >
                <>
                    <SlideInImage slideInImage={slideInImage} slideInImageAnimation={slideInImageAnimation} />
                    <Container>
                        <ContentWrapper>
                            <HeroHeader header={header} mode={mode} />
                            <HeroDescription description={description} mode={mode} />
                            {MiddleContent}
                            <WidgetElement showQuoteForm={showQuoteForm} quoteFormDefaultMode={quoteFormDefaultMode} />
                        </ContentWrapper>
                    </Container>
                </>
            </BackgroundImage>
        </HeroWrapper>
    )
}
